import { ActionTree } from 'vuex';
import { RootState } from '../types';
import { FunctionsState} from './types';

export const actions: ActionTree<FunctionsState, RootState> = {

};
